<template>
  <div class="rooms responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'returns', label: 'Returns' },
        ]"
        :entity="entity"
        :hideAddButton="true"
      />
      <SearchTable
        :entity="entity"
        :filter="{ isDeleted: false }"
        :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" 
      />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import Entities from "@/resources/Entities";
import SearchTable from "@/components/SearchTable.vue";

import { columnHeaders, listPageHeader } from "./inputs";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "returns",
  data() {
    return {
      Entities,
      entity: Entities.RETURNITEM,
      listPageHeader,
      columnHeaders,
    };
  },
  components: {
    PageHeader,
    SearchTable,
  },
  mounted: function () {
    this.setPageTitle("Returns");
  },
  computed: {
    ...mapGetters({
      sort: "returnItemModule/sort",
      pagination: "returnItemModule/pagination",
      initialFilter: "returnItemModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "returnItemModule/updateSort",
      updatePagination: "returnItemModule/updatePagination",
      updateInitialFilter: "returnItemModule/updateInitialFilter"
    }),
  }
};
</script>
